import { Cpu, Brain, Radio, Code2, CircuitBoard, Zap, Cloud, Database, Layers, Wifi, GitBranch, Boxes } from "lucide-react";

const items = [
  { icon: Brain, label: "Artificial Intelligence" },
  { icon: Radio, label: "IoT · MQTT · Telemetry" },
  { icon: Code2, label: "Software Engineering" },
  { icon: CircuitBoard, label: "Hardware Prototype" },
  { icon: Zap, label: "Smart Energy" },
  { icon: Cloud, label: "Cloud Deployment" },
  { icon: Layers, label: "Product Management" },
  { icon: Cpu, label: "Embedded Systems" },
  { icon: Database, label: "Data & Analytics" },
  { icon: Wifi, label: "System Integration" },
  { icon: GitBranch, label: "Delivery Pipeline" },
  { icon: Boxes, label: "Microservices" },
];

const Row = ({ reverse }) => (
  <div className={`flex gap-3 sm:gap-4 whitespace-nowrap ${reverse ? "animate-marquee" : "animate-marquee"}`} style={{ animationDirection: reverse ? "reverse" : "normal" }}>
    {[...items, ...items].map((it, i) => {
      const Icon = it.icon;
      return (
        <div
          key={i}
          className="shrink-0 inline-flex items-center gap-2.5 px-4 py-2.5 rounded-full glass text-sm text-slate-300 hover:text-white hover:border-blue-400/40 transition-colors"
        >
          <Icon className="w-4 h-4 text-blue-300" strokeWidth={1.5} />
          {it.label}
        </div>
      );
    })}
  </div>
);

const TechMarquee = () => {
  return (
    <section
      data-testid="tech-marquee-section"
      className="relative py-10 lg:py-14 overflow-hidden border-y border-white/[0.05] bg-[#080d22]"
    >
      <div className="absolute inset-0 grid-bg-fine opacity-60 pointer-events-none" />
      {/* edge masks */}
      <div className="pointer-events-none absolute inset-y-0 left-0 w-32 bg-gradient-to-r from-[#080d22] to-transparent z-10" />
      <div className="pointer-events-none absolute inset-y-0 right-0 w-32 bg-gradient-to-l from-[#080d22] to-transparent z-10" />

      <div className="space-y-3 sm:space-y-4">
        <Row />
        <Row reverse />
      </div>
    </section>
  );
};

export default TechMarquee;
